module.exports = __webpack_public_path__ + "static/media/thumbsDown.6ee8d181.svg";